// creditapps
export const UPDATE_CURRENT_CREDIT_APP = 'UPDATE_CURRENT_CREDIT_APP';

// quick qualify
export const UPDATE_CURRENT_QUICK_QUALIFICATION = 'UPDATE_CURRENT_QUICK_QUALIFICATION';

// lead
export const UPDATE_CURRENT_LEAD = 'UPDATE_CURRENT_LEAD';

// lead
export const UPDATE_CURRENT_CLIENT = 'UPDATE_CURRENT_CLIENT';

// auth
export const  TOKEN = 'TOKEN'
export const  IS_AUTHENTICATED = 'IS_AUTHENTICATED'
export const  UPDATE_USER = 'UPDATE_USER'
